export default __webpack_public_path__ + "260545f.png";